export interface IGenerateBatchOperation {
  orderIds: number[];
  shopProviderKey: string;
  operationId: string;
}


